import GigyaEventAuthenticationValueObject from './GigyaEventAuthenticationValueObject.js'
import LoginInfoAuthenticationValueObject from './LoginInfoAuthenticationValueObject.js'
import ScreensetValueObject from './ScreensetValueObject.js'
import VerifyAuthenticationValueObject from './VerifyAuthenticationValueObject.js'

export default class AuthenticationValueObjectsFactory {
  static gigyaEventAuthenticationValueObject = ({eventName, screenSet, formData = {}, errorCode}) =>
    new GigyaEventAuthenticationValueObject({eventName, screenSet, formData, errorCode})

  static loginInfoAuthenticationValueObject = ({isNewUser, loginProvider, url, userData, identify}) => {
    return new LoginInfoAuthenticationValueObject({
      isNewUser,
      loginProvider,
      url,
      userData,
      ...(identify && {identify})
    })
  }

  static screensetValueObject = ({screenset}) => new ScreensetValueObject({screenset})

  static verifyAuthenticationValueObject = ({logged}) => new VerifyAuthenticationValueObject({logged})
}
